export default __webpack_public_path__ + "static/media/union-contact-gray.f2b738d0.svg";